<template>
  <div class="ui-menu">
    <div
      class="ui-menu-wrapper"
      :class="{ 'ui-menu-fold': type === 'fold' }"
      :style="{ width: `${type === 'unfold' ? width : foldWidth}px` }"
    >
      <div
        class="ui-menu-list pointer"
        ref="menuScrollList"
        :style="{ width: `${width + scrollWidth}px` }"
      >
        <div
          v-for="(menu, index) in data"
          :key="menu.path"
          class="ui-menu-item parent-menu-item"
        >
          <template v-if="menu.children && menu.children.length > 0">
            <div
              class="ui-menu-item-header"
              :class="{ actived: type === 'fold' ? menu.actived : false }"
              :style="{ height: `${itemHeight+8}px` }"
              @click="onClickMenuItem(null, menu, index)"
              @mouseenter="mouseenterItem(menu, index)"
              @mouseleave="mouseleaveItem"
            >
              <div
                class="ui-menu-item-icon"
                :style="{ width: `${foldWidth}px` }"
              >
                <CIcon class="font-small" :icon="menu.icon" size="20px"></CIcon>
              </div>

              <div class="ui-menu-item-text cmsc-ellipsis" :title="menu.title">
                {{ menu.title }}
              </div>
              <div
                class="ui-menu-item-icon"
                :style="{ width: `${foldWidth}px` }"
              >
                <CIcon
                  class="expand-icon"
                  icon="tongyong-zhankailiebiao1"
                  :class="{ actived: menu.actived }"
                ></CIcon>
              </div>
            </div>
            <div
              class="ui-submenu-wrapper theme-bg-darkest-color"
              :class="{ actived: menu.actived }"
              :style="{
                height:
                  menu.actived && type === 'unfold'
                    ? menu.children.length * itemHeight + 'px'
                    : '0px'
              }"
            >
              <div class="ui-submenu-list">
                <div
                  v-for="submenu in menu.children"
                  :key="submenu.path"
                  class="ui-menu-item"
                >
                  <div
                    class="ui-menu-item-header"
                    :class="{ actived: submenu.actived }"
                    :style="{ height: `${itemHeight}px`,fontSize: '14px' }"
                    @click="onClickMenuItem(menu, submenu, index)"
                  >
                    <div
                      class="ui-menu-item-text cmsc-ellipsis"
                      :title="submenu.title"
                      :style="{ paddingLeft: `${foldWidth}px` }"
                    >
                      {{ submenu.title }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div
              class="ui-menu-item-header"
              :class="{ actived: menu.actived }"
              :style="{ height: `${itemHeight+8}px` }"
              @click="onClickMenuItem(null, menu, index)"
              @mouseenter="mouseenterItem(menu, index)"
              @mouseleave="mouseleaveItem"
            >
              <div
                class="ui-menu-item-icon"
                :style="{ width: `${foldWidth}px` }"
              >
                <CIcon class="font-small" :icon="menu.icon" size="20px"></CIcon>
              </div>
              <div class="ui-menu-item-text">{{ menu.title }}</div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <TitleTip
      :text="foldMenuTitleTip.text"
      :top="foldMenuTitleTip.top"
      v-show="foldMenuTitleTip.actived"
      :style="{ left: foldWidth + 10 + 'px' }"
    ></TitleTip>
    <SubmenuPopup
      :menu="submenuPopup.menu"
      :top="submenuPopup.top"
      :actived="submenuPopup.actived"
      :style="{ left: foldWidth + 10 + 'px' }"
      @on-click="onClickSubmenuHandler"
    ></SubmenuPopup>
  </div>
</template>
<script>
import TitleTip from './TitleTip'
import SubmenuPopup from './SubmenuPopup'
import { stringify } from 'qs'
export default {
  name: 'Menu',
  components: {
    TitleTip,
    SubmenuPopup
  },
  props: {
    itemHeight: {
      type: Number,
      default() {
        return 50
      }
    },
    width: {
      type: Number,
      default() {
        return 300
      }
    },
    foldWidth: {
      type: Number,
      default() {
        return 50
      }
    },
    type: {
      type: String,
      default() {
        return 'unfold'
      }
    },
    data: Array
  },
  data() {
    return {
      mouseleaveTimer: null,
      foldMenuTitleTip: {
        actived: false,
        text: '',
        top: 0
      },
      submenuPopup: {
        actived: false,
        menu: null,
        top: 0
      },
      scrollWidth: 0
    }
  },
  watch: {
    type(value, oldValue) {
      if (value !== oldValue) {
        this.inactivedAllMenu()
        this.activedMenuItemByRoute(this.$route)
      }
    },
    $route: {
      handler(route) {
        if (route) {
          this.inactivedAllMenu()
          this.activedMenuItemByRoute(route)
        }
      },
      deep: true,
      immediate: true
    },
    data(value,oldValue) {
      if(value.length!=oldValue.length){
        this.activedMenuItemByRoute(this.$route)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.scrollWidth =
        this.$refs.menuScrollList.offsetWidth -
        this.$refs.menuScrollList.clientWidth
      document.body.addEventListener('click', this.closeSubmenuPopup, true)
    })
  },
  beforeDestroy() {
    document.body.removeEventListener('click', this.closeSubmenuPopup, true)
  },
  methods: {
    onClickMenuItem(parentMenu, menu, index) {
      if (this.type === 'unfold') {
        if (menu.children && menu.children.length > 0) {
          //有三级
          if(parentMenu&&parentMenu.children.length){
            this.$store.commit('main/menus/setThirdMenus',menu.children)
            let thirdMenu = menu.children[0]
            this.$router.push({
                path: thirdMenu.path,
                query: {
                    id: thirdMenu.id
                },
                params: thirdMenu.params
            })
            this.$set(menu, 'actived', true)
          }else{
            this.$set(menu, 'actived', !menu.actived)
          }
        } else {
          this.inactivedAllMenu('subLevel')
          // this.$set(menu, 'actived', true)
          // if (parentMenu) {
          //   this.$set(menu, 'actived', true)
          //   //this.inactivedAllMenu('topLevel')
          // }
          this.$emit('on-click', { ...menu, parentMenu })
        }
      } else {
        // if (!parentMenu) {
        if (menu.children && menu.children.length > 0) {
          this.foldMenuTitleTip.actived = false
          this.submenuPopup.menu = menu
          const top =
            document.querySelectorAll('.ui-menu-list .parent-menu-item')[index]
              .offsetTop -
            document.querySelector('.ui-menu-list').scrollTop +
            this.itemHeight * 0.5
          const popupHalfHeight = (menu.children.length * 48 + 48) / 2
          this.submenuPopup.top =
            popupHalfHeight - top > 0 ? popupHalfHeight : top
          this.submenuPopup.actived = true
          // this.$emit('on-click', menu)
        } else {
          this.$emit('on-click', { ...menu, parentMenu })
        }
      }
    },
    activedMenuItemByRoute(route) {
      this.$store.commit('main/menus/setThirdMenus',[])
      if (route.query.parents) {
        let parentMenu = this.getMenuById(this.data, route.query.parents)
        if (parentMenu) {
          this.$set(parentMenu, 'actived', true)
          let subMenu = this.getMenuByRoute(parentMenu.children, route)
          if (subMenu) this.$set(subMenu, 'actived', true)
        }
      } else {
        let target = this.getMenuByRoute(this.data, route)
        console.log('third---',target)
        if (target) {
          this.$set(target, 'actived', true)
          if (target.parents) {
            // let parentsMenu = this.data.find(
            //   item => item.path === target.parents
            // )
            let parentsMenu = null
            for(let i in this.data){
              let item = this.data[i]
              if(item.path === target.parents){
                parentsMenu = item
              }
              if(item.children&&item.children.length){
                for(let k in item.children){
                  //第二层
                  if(item.children[k].path === target.parents){
                    parentsMenu =  item.children[k]
                    //这里设置三级菜单
                    console.log('third---',item)
                    if(item.children[k].children){
                      item.children[k].children.forEach(_key => {
                        if(_key.path!=route.path){
                          this.$set(_key, 'actived', false)
                        }
                      })
                      this.$store.commit('main/menus/setThirdMenus',item.children[k].children)
                    }
                  }
                }
              }
            }
            if (parentsMenu) this.$set(parentsMenu, 'actived', true)
            if (parentsMenu.parents){
              let grantParentsMenu = this.data.find(
                item => item.path === parentsMenu.parents
              )
              if (grantParentsMenu) this.$set(grantParentsMenu, 'actived', true)
            }
          }
        }
      }
    },
    onClickSubmenuHandler(menu) {
      this.$emit('on-click', menu)
    },
    inactivedAllMenu(target) {
      this.data.forEach(menu => {
        if (!target || target === 'topLevel') {
          if (menu.actived) this.$set(menu, 'actived', false)
        }
        if (!target || target === 'subLevel') {
          if (menu.children && menu.children.length > 0) {
            menu.children.forEach(submenu => {
              if (submenu.actived) this.$set(submenu, 'actived', false)
            })
          }
        }
      })
    },
    mouseenterItem(menu, index) {
      if (this.type === 'fold') {
        if (menu.children && menu.children.length > 0) {
          this.foldMenuTitleTip.actived = false
          this.submenuPopup.menu = menu
          const top =
            document.querySelectorAll('.ui-menu-list .parent-menu-item')[index]
              .offsetTop -
            document.querySelector('.ui-menu-list').scrollTop +
            this.itemHeight * 0.5
          const popupHalfHeight = (menu.children.length * 48 + 48) / 2
          this.submenuPopup.top =
            popupHalfHeight - top > 0 ? popupHalfHeight : top
          this.submenuPopup.actived = true
          // this.$emit('on-click', menu)
        }
        return
        if (!this.submenuPopup.actived) {
          clearTimeout(this.mouseleaveTimer)
          this.foldMenuTitleTip.actived = true
          this.foldMenuTitleTip.text = menu.title
          const top =
            document.querySelectorAll('.ui-menu-list .parent-menu-item')[index]
              .offsetTop - document.querySelector('.ui-menu-list').scrollTop
          this.foldMenuTitleTip.top = top + this.itemHeight * 0.5
        } else {
          if (!menu.children || menu.children.length === 0)
            return (this.submenuPopup.actived = false)
          const top =
            document.querySelectorAll('.ui-menu-list .parent-menu-item')[index]
              .offsetTop -
            document.querySelector('.ui-menu-list').scrollTop +
            this.itemHeight * 0.5
          const popupHalfHeight = (menu.children.length * 48 + 48) / 2
          this.submenuPopup.top =
            popupHalfHeight - top > 0 ? popupHalfHeight : top
          this.submenuPopup.menu = menu
        }
      }
    },
    mouseleaveItem() {
      if (this.type === 'fold') {
        this.mouseleaveTimer = setTimeout(() => {
          this.foldMenuTitleTip.actived = false
        }, 100)
      }
    },
    createPoporDOM(type, id, menu, index) {
      let DOM = document.createElement('div')
      DOM.id = id
      if (type === 'tooltip') {
        DOM.innerText = menu.title
      } else {
        if (menu.children && menu.children.length > 0) {
          menu.children.forEach(item => {
            let submenuDOM = document.createElement('div')
            submenuDOM.classList.add(id + '-item')
            submenuDOM.innerText = item.title
            DOM.appendChild(submenuDOM)
          })
        }
      }

      DOM.style.top = this.itemHeight * (index + 0.5) + 'px'
      DOM.style.left = this.itemHeight + 10 + 'px'
      return DOM
    },
    closeSubmenuPopup() {
      this.submenuPopup.actived = false
    },
    getMenuById(menus, id) {
      for (let i = 0; i < menus.length; i++) {
        let item = menus[i]
        if (item.id === id) {
          return item
        } else {
          if (item.children && item.children.length > 0) {
            let deepReturn = this.getMenuById(item.children, id)
            if (deepReturn) {
              return deepReturn
            }
          }
        }
      }
    },
    /**
     * 通过当前路由匹配菜单。通过不同的菜单类型，采用不一样的匹配规则，确保做到唯一匹配。
     */
    getMenuByRoute(menus, route) {
      for (let i = 0; i < menus.length; i++) {
        let item = menus[i]
        let isMatched = false
        if (route.meta.type === 'object') {
          if (
            route.path === item.path &&
            route.query.objectId === item.params.objectId
          ) {
            isMatched = true
          }
        } else if (route.meta.type === 'external') {
          if (
            route.path === item.path &&
            route.query.externalSrc ===
              `${item.params.externalSrc}?${stringify(
                item.params.externalParams
              )}`
          ) {
            isMatched = true
          }
        } else {
          if (route.path === item.path) {
            isMatched = true
          }
        }
        if (isMatched) {
          return item
        } else {
          if (item.children && item.children.length > 0) {
            let deepReturn = this.getMenuByRoute(item.children, route)
            if (deepReturn) {
              return deepReturn
            }
          }
        }
      }
    }
  }
}
</script>
<style lang="stylus">
.ui-menu
  position relative
  height 100%
  float left

.ui-menu-wrapper
  height 100%
  overflow hidden
  transition width 0.3s

  .ui-menu-list
    height 100%
    overflow-y scroll

    .parent-menu-item:last-child
      margin-bottom 50px

    .ui-menu-item
      &-header
        display flex
        justify-content flex-start
        align-items center
        transition background-color 0.3s
        font-size 16px
        color #fff
        cursor pointer

        &:hover
          background #04cbd8

        &.actived
          background #04cbd8

      &-icon
        display flex
        justify-content center
        align-items center
        height 100%

        .expand-icon
          transition transform 0.3s

          &.actived
            transform rotateZ(180deg)

      &-text
        width 0
        flex auto
        white-space nowrap

.ui-submenu-wrapper
  height 0
  overflow hidden
  transition height 0.2s
  background #eee

  .ui-menu-item
    &-header
      &.actived
        background #04cbd8
.scmcc-sidebar-fold 
  .ui-menu-wrapper
    .ui-menu-list
      .ui-menu-item
          &-header
            &.actived
              background #1D253A
</style>